import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

const CurrentBlogTemplate = () => {
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(false);

    const MobileBlogCSS = (
        <style>{`
        @media (max-width: 480px) {
            .refresh-btn-home {
                position: static !important; /* Force static para sumunod sa flow */
                display: block !important;
                margin: 0 auto 15px auto !important; /* I-center sa mobile */
                width: fit-content;
            }
            .blog-card-mobile {
                padding-top: 20px !important;
                display: flex;
                flex-direction: column;
            }
            .dyk-title {
                padding-top: 0 !important; /* No need for padding pag static na yung button */
            }
        }
        `}</style>
    );

    // Ginawa nating function para pwede nating tawagin ulit (Refresh)
    const fetchRandomBlog = useCallback(() => {
        setLoading(true);
        fetch("https://albiemer.onrender.com/api/homeapi/")
            .then(response => response.json())
            .then(data => {
                setBlog(data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching random blog:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        fetchRandomBlog();
    }, [fetchRandomBlog]);

    if (!blog && loading) return (
        <div className="blogcontainer">
            <p>Loading Technical Trivia...</p>
        </div>
    );

    return (
        <>
            {MobileBlogCSS}
            <div className="blogcontainer">
                <div className="card" style={{ position: "relative" }}>
                    
                    {/* REFRESH BUTTON - Nilagyan ng class para sa mobile logic */}
                    <button 
                        className="refresh-btn-home"
                        onClick={fetchRandomBlog}
                        disabled={loading}
                        style={{
                            position: window.innerWidth <= 480 ? "relative" : "absolute", // Relative sa mobile para 'di mag-overlap
                            top: window.innerWidth <= 480 ? "0" : "15px",
                            right: window.innerWidth <= 480 ? "0" : "15px",
                            display: "block",
                            margin: window.innerWidth <= 480 ? "0 auto 15px auto" : "0", // Gitna sa mobile
                            background: "transparent",
                            border: "1px solid #0ff",
                            color: "#0ff",
                            borderRadius: "5px",
                            padding: "5px 12px",
                            cursor: "pointer",
                            fontSize: "0.8rem",
                            zIndex: 10
                        }}
                    >
                        {loading ? "Syncing..." : "↻ Refresh"}
                    </button>

                    <h1 style={{ textAlign: "center", marginBottom: "5px", fontSize: "clamp(1.5rem, 8vw, 2.5rem)" }}>
                        DID YOU KNOW?
                    </h1>
                    
                    <p style={{ 
                        textAlign: "center", 
                        fontSize: "0.85rem", 
                        color: "#666", 
                        marginTop: "0",
                        fontStyle: "italic" 
                    }}>
                        Randomized Entry From My Custom Technical Microblogging System
                    </p>

                    <hr />

                    <h2 style={{ 
                        textAlign: "center", 
                        width: "100%", 
                        marginBottom: "15px", 
                        fontSize: "clamp(1.2rem, 5vw, 1.8rem)",
                        opacity: loading ? 0.5 : 1 // Visual cue pag naglo-load
                    }}>
                        {blog?.title}
                    </h2>
                    
                    <div className="fakeimg" style={{ height: "auto", width: "90%", opacity: loading ? 0.5 : 1 }}>
                        <img src={blog?.image} alt={blog?.title} loading="lazy" />
                    </div>

                    <div style={{ fontSize: "0.9rem", marginTop: "10px" }}>
                        [{blog?.date}] - <b>{blog?.author}</b>
                    </div>

                    <p style={{ whiteSpace: "pre-wrap", marginTop: "15px", opacity: loading ? 0.5 : 1 }}>
                        {blog?.content}
                    </p>

                    <Link to="/blogs" style={{ textDecoration: "none", display: "block", marginTop: "20px" }}>
                        <button style={{
                            width: "100%",
                            padding: "12px",
                            background: "#000",
                            color: "cyan",
                            border: "none",
                            borderRadius: "8px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            fontSize: "1rem"
                        }}>
                            See more micro blog Post...
                        </button>
                    </Link>
                </div>
            </div>
            <br />
        </>
    );
};

export default CurrentBlogTemplate;